module.exports = __webpack_public_path__ + "img/hall_slide01.51c8a087.jpg";